import {
  managedKnowledgeItemSchema,
  managedKnowledgeRefSchema,
} from "@redotech/shopper-agent-knowledge-common/managed-knowledge-view";
import * as z from "zod";

/** One entry of either corpus, with its body. FAQ entries are read-only. */
export const getKnowledgeItem = {
  name: "getKnowledgeItem" as const,
  input: z.object({ ref: managedKnowledgeRefSchema }),
  output: managedKnowledgeItemSchema,
};
